import {REPRESENTATION} from './representation.model';

/** Ordre d'affichage des représentations dans le paramétrage : la plus courante d'abord. */
export const RATED_REPRESENTATIONS: REPRESENTATION[] = [
    REPRESENTATION.NUMBER,
    REPRESENTATION.VISUAL,
    REPRESENTATION.TEXT,
];
